module.exports = __webpack_public_path__ + "html/subscription_6c1671fc060c53c339cea4db3b0b84df.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/settings/subscription.html
// module id = py5d
// module chunks = 3 9